import React from "react";
import { useYear } from "../context/YearContext";
import { ChevronDown } from "lucide-react";

const ADD_YEAR = "__ADD_YEAR__";

export default function TopBar({ title, subtitle, actions }) {
  const { year, setYear, years, refreshYears } = useYear();

  const onYearChange = (v) => {
    if (v === ADD_YEAR) {
      const input = window.prompt("Enter year to track (e.g. 2023):");
      const n = parseInt(input, 10);
      if (n && n > 1900 && n < 3000) {
        setYear(n);
        refreshYears();
      }
      return;
    }
    setYear(parseInt(v));
  };

  return (
    <div className="no-print flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4 sm:gap-6 mb-6 sm:mb-8" data-testid="topbar">
      <div>
        <div className="text-[11px] font-semibold tracking-[0.14em] uppercase text-[#BC4727]">
          AcreLatch
        </div>
        <h1 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold text-[#1F2A47] mt-1 tracking-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="text-sm text-slate-600 mt-2 max-w-xl leading-relaxed">{subtitle}</p>
        )}
      </div>
      <div className="flex items-end sm:items-start gap-3 shrink-0 flex-wrap">
        {actions}
        <div className="relative" data-testid="year-selector-wrap">
          <label className="block text-[10px] font-semibold tracking-[0.14em] uppercase text-slate-500 mb-1.5">
            Tax Year
          </label>
          <div className="relative">
            <select
              data-testid="year-selector"
              value={years.includes(year) ? year : year}
              onChange={(e) => onYearChange(e.target.value)}
              className="appearance-none bg-white border border-slate-200 px-4 py-2 pr-10 text-base font-bold tabular rounded-xl shadow-sm hover:border-[#1F2A47] focus:outline-none focus:ring-2 focus:ring-[#1F2A47]/20 cursor-pointer transition-colors"
            >
              {(years.includes(year) ? years : [year, ...years]).map((y) => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
              <option value={ADD_YEAR}>+ Add year…</option>
            </select>
            <ChevronDown className="w-4 h-4 absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-slate-500" />
          </div>
        </div>
      </div>
    </div>
  );
}
